import * as ActionTypes from '../actions/actionTypes'
import objectPath from 'object-path'

export default function reduce(state = {}, action) {
    switch(action.type) {

        case ActionTypes.SET_TTS_INITIALIZE_COMPLETE:
        {
            let completedLocation = action.payload.stateLocation;
            let newState = Object.assign({}, state);
            objectPath.set(newState, completedLocation, true);
            return newState;
        }
        case ActionTypes.SET_STATE_TTS_PLAY_PRV_ON_NAV:
        {
            let stagingLocation = action.payload.stateLocation;
            let value = action.payload.value;

            let newState = Object.assign({}, state);
            objectPath.set(newState, stagingLocation, value);
            return newState;
        }   
        case ActionTypes.SET_STATE_TTS_WAS_PLAYED:
        {    let stagingLocation = action.payload.stateLocation;
            let value = action.payload.value;

            let newState = Object.assign({}, state);
            objectPath.set(newState, stagingLocation, value);
            return newState;
        }   
        case ActionTypes.SET_STATE_TTS_SHOULD_PLAY:
        {
            let stagingLocation = action.payload.stateLocation;
            let value = action.payload.value;

            let newState = Object.assign({}, state);
            objectPath.set(newState, stagingLocation, value);
            return newState;
        }
        case ActionTypes.SET_STATE_TTS_LAST_PRV_URL:
        {
            let stagingLocation = action.payload.stateLocation;
            let value = action.payload.value;

            let newState = Object.assign({}, state);
            objectPath.set(newState, stagingLocation, value);
            return newState;
        }
        case ActionTypes.SET_STATE_TTS_SOUND_MONITOR_TIMER:
        {
            let stagingLocation = action.payload.stateLocation;
            let value = action.payload.value;

            let newState = Object.assign({}, state);
            objectPath.set(newState, stagingLocation, value);
            return newState;
        }
        case ActionTypes.SET_STATE_TTS_AUDIO_PLAY_TIMER:
        {
            let stagingLocation = action.payload.stateLocation;
            let value = action.payload.value;

            let newState = Object.assign({}, state);
            objectPath.set(newState, stagingLocation, value);
            return newState;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/response-handler-tts/src/reducers/index.js